import { useQuery } from "@tanstack/react-query";
import api from "../core/api";
import publicApi from "../core/publicApi";
import { queryKeys } from "./queryKeys";

/**
 * Testi del contratto in vigore (Condizioni Generali, Allegati, Informativa
 * Privacy), già divisi in blocchi dal backend. Pubblici: servono anche nel
 * wizard di registrazione, prima che esista un account. Si rileggono a ogni
 * apertura della firma: si firma solo la versione appena mostrata.
 */
export function useContrattoTesti({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.contrattoTesti,
    queryFn: () => publicApi.get("/api/public/contratto").then((r) => r.data),
    enabled,
    staleTime: 0,
  });
}

/** Stato della firma dello studio (firmato, da firmare, chi può firmare). */
export function useStatoContratto({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.contratto,
    queryFn: () => api.get("/api/contratto/stato").then((r) => r.data),
    enabled,
  });
}

export const CONSENSI_VUOTI = { contratto: false, clausole: false, privacy: false };

/** Campi da inviare a /register e a /api/contratto/firma. */
export function payloadConsensi(testi, consensi) {
  return {
    contrattoVersioneId: testi?.id,
    consensoContratto: Boolean(consensi.contratto),
    consensoClausole: Boolean(consensi.clausole),
    consensoPrivacy: Boolean(consensi.privacy),
  };
}

export const consensiCompleti = (consensi) => Boolean(consensi.contratto && consensi.clausole && consensi.privacy);
